
namespace RioERP.Invoices {
    export class InvoiceOrdersColumns {
        static columnsKey = 'Invoices.InvoiceOrders';
    }
}